var render = function render(_c,_vm){return _c('svg',_vm._g(_vm._b({staticClass:"icon plus",class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('path',{attrs:{"d":"M13 11h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1-2 0v-6H5a1 1 0 0 1 0-2h6V5a1 1 0 0 1 2 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }